import { ArrowUpDown } from 'lucide-react';
import { SortButtonProps } from './types';
import { EntitySortOrder } from '../../../lib/enums';

export const SortButton = ({
  sortOrder,
  onSortChange,
  disabled = false,
}: SortButtonProps) => {
  const handleClick = () => {
    const newSortOrder =
      sortOrder === EntitySortOrder.Alphabetical
        ? EntitySortOrder.MostRecent
        : EntitySortOrder.Alphabetical;
    onSortChange(newSortOrder);
  };

  const displayText =
    sortOrder === EntitySortOrder.Alphabetical ? 'A-Z' : 'Most recent';

  return (
    <button
      type="button"
      onClick={handleClick}
      className="flex items-center gap-1 text-xs text-prompt-safecomabbey transition-colors hover:text-prompt-safecomvulcan"
      disabled={disabled}
    >
      <ArrowUpDown className="h-3 w-3" />
      <span>Sort: {displayText}</span>
    </button>
  );
};
